import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { firstValueFrom } from 'rxjs';
import { GlobalVariable } from '../global';

@Injectable({ providedIn: 'root' })
export class MsalTokenService {

  constructor(private msal: MsalService) {}

  async getToken(): Promise<string | null> {
    const active = this.msal.instance.getActiveAccount();

    if (!active) {
      console.warn('⚠ No active MSAL account. Redirecting...');
      await this.login();
      return null;
    }
    try {
      const result: AuthenticationResult = await firstValueFrom(this.msal.acquireTokenSilent({
        scopes: [GlobalVariable.SSOAPIID],
        account: active
      }));      
      return result.accessToken;
    } catch (e) {
      console.warn('Silent token failed → redirecting...', e);
      await this.login();
      return null;
    }
  }

  async login(): Promise<void> {
    await this.msal.loginRedirect({
      scopes: ['user.read']
    });
  }
}
